import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/HomeNavBar/HomeNavBar.vue';
import { get_user_details, get_token } from '@/router';
import Swal from 'sweetalert2';
import CreateFeed from '@/components/CreateFeed/CreateFeed.vue';
import { append_active_organization_id } from '@/utils/organization_profile';


export default {
  components: {
    Sidebar,
    Navbar,
    CreateFeed
  },
  inject: ['client_features'],
  computed: {
    all_selected_tags() {
      let tags = [];
      this.selected_tags.forEach(arr => {
        tags.push(...arr);
      });
      if (this.primary_tag) {
        const primaryId = this.primary_tag.id;

        tags = [
          {
            id: this.primary_tag.id,
            name: this.primary_tag.name
          },

          // all others except primary
          ...tags.filter(t => t.id !== primaryId)
        ];
      }

      return tags;
    },
    feed_dashboard_cards() {
      return this.build_feed_dashboard_cards().filter(Boolean);
    },
    tagged_feed_count() {
      return this.reports.filter(report => report.tags?.length).length;
    },
    untagged_feed_count() {
      return this.reports.length - this.tagged_feed_count;
    },
    segmented_feed_count() {
      return this.reports.filter(report => report.topic).length;
    },
    feed_portal_count() {
      return new Set(this.reports.map(report => report.portal?.id || report.portal?.name).filter(Boolean)).size;
    },
    feed_author_count() {
      return new Set(this.reports.flatMap(report => this.get_feed_author_names(report))).size;
    },
    total_feed_likes() {
      return this.reports.reduce((total, report) => total + Number(report.total_likes || 0), 0);
    },
    total_feed_comments() {
      return this.reports.reduce((total, report) => total + Number(report.total_comments || 0), 0);
    },
  },

  data() {
    return ({
      reports: [],

      linkPreview: null,
      report_edit: [],
      edit_authors: [],
      edit_author_input: '',  // input for author name
      edit_author_link: '',
      temporaryPost: null,
      report_id: null,
      report_description: "",
      isLoading: false,
      token_exists: false,
      user_id: null,
      edit_report_link: '',
      report_data: {},
      edit_documents: [],
      audio_file_name: '',
      upload_media: null,
      fileError: '',
      audioError: '',
      editFileName: '',
      topics: [],
      categories: [],
      selected_tags: new Map(),
      reportsByCategories: [],
      subjects: [],
      selectedCategories: new Map(),
      primary_tag: null,
      showAllPrimary: false,
      showAllSecondary: false,
      primary_tags: new Map(),
      isCategoryModalOpenedFromFeed: false,
      comments_off: true,
      active_profile: null,
      selected_report: null,
      user_details: {
        user_role: '',
        user_id: '',
        first_name: '',
        last_name: '',
      },
    });
  },

  mounted() {
    this.user_details = get_user_details();
    this.fetch_grouped_tags();

    const tag_id = this.$route.params.tag_id;
    const topic_id = this.$route.params.topic_id;
    let fetch_report_data;

    if (tag_id) {
      fetch_report_data = this.fetch_reports_by_tags();

      // If topic_id exists → fetch reports by topic
    } else if (topic_id) {
      // If tag_id exists → fetch reports by tags
      fetch_report_data = this.fetch_reports_by_topic();

    }
    else {
      // Otherwise → fetch all reports
      fetch_report_data = this.fetch_reports();
    }

    fetch_report_data.catch((error) => {
      console.error('Failed to load topic reports:', error);
      this.is_loading = false;
    });

    this.token_exists = get_token();
  },

  methods: {
    toggle_sidebar() {
      this.$refs.sidebar?.$el?.classList.toggle('close');
    },

    getToken() {
      return get_token();
    },
    build_feed_dashboard_cards() {
      return [
        { label: 'Total feeds', value: this.reports.length, icon: 'bi-journal-text', tone: 'primary' },
        this.get_feed_tags_card(),
        this.get_untagged_feed_card(),
        this.get_feed_portals_card(),
        this.get_feed_authors_card(),
        { label: 'Likes', value: this.total_feed_likes, icon: 'bi-hand-thumbs-up-fill', tone: 'primary' },
        { label: 'Comments', value: this.total_feed_comments, icon: 'bi-chat-dots-fill', tone: 'success' },
      ];
    },
    get_feed_tags_card() {
      return this.can_show_feed_tags
        ? { label: 'Tagged', value: this.tagged_feed_count, icon: 'bi-tags-fill', tone: 'success' }
        : null;
    },
    get_untagged_feed_card() {
      return this.can_show_feed_tags
        ? { label: 'Without tags', value: this.untagged_feed_count, icon: 'bi-tag', tone: 'secondary' }
        : null;
    },
    get_feed_portals_card() {
      return this.can_show_feed_portals
        ? { label: 'Portals', value: this.feed_portal_count, icon: 'bi-grid-1x2-fill', tone: 'warning' }
        : null;
    },
    get_feed_authors_card() {
      return this.can_show_feed_authors
        ? { label: 'Authors', value: this.feed_author_count, icon: 'bi-pencil-square', tone: 'dark' }
        : null;
    },
    get_feed_author_names(report) {
      if (report.authors?.length) {
        return report.authors.map(author => author.author_name || author.name).filter(Boolean);
      }

      return [
        report.company?.company_name,
        [report.base_profile?.user?.first_name, report.base_profile?.user?.last_name].filter(Boolean).join(' '),
      ].filter(Boolean);
    },
    initDataTable(id) {
      const table = $(id);

      if (!table.length) return;

      if ($.fn.DataTable.isDataTable(id)) {
        table.DataTable().clear().destroy();
      }

      table.DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        lengthChange: true,
        pageLength: 10,
        language: {
          paginate: {
            previous: "Previous",
            next: "Next"
          },
          info: "Showing _START_ to _END_ of _TOTAL_ entries",
          infoEmpty: "No entries available",
          emptyTable: "No feeds yet."
        }
      });
    },
    syncReportsTable(resolve) {
      this.is_loading = false;
      this.$nextTick(() => {
        this.initDataTable('#report-table');
        resolve();
      });
    },

    isLastTag(tag, list) {
      return list[list.length - 1] === tag
    },
    open_edit_category_modal(report) {
      // Hide the edit report modal
      $('#edit_report_modal').modal('hide');

      // Populate primary tags
      if (report.primary_tag) {
        const categoryId = report.primary_tag.tag_category.id;
        this.primary_tags.set(categoryId, report.primary_tag);
      }
      $('#category_modal_edit').modal('show');
    },

    open_edit_author_modal() {
      $('#edit_report_modal').modal('hide');
      $('#author_modal_edit').modal('show');
    },
    add_author_method() {
      const name = this.edit_author_input.trim();
      const link = this.edit_author_link.trim() || '';

      if (!name) return;

      // Push to edit_authors array
      if (!this.edit_authors) this.edit_authors = [];
      this.edit_authors.push({
        author_name: name,
        author_link: link
      });

      // Clear inputs
      this.edit_author_input = '';
      this.edit_author_link = '';
    },

    remove_author_method(index) {
      this.edit_authors.splice(index, 1);
    },

    save_edit_author() {
      this.report_edit.authors = this.edit_authors;

      $('#author_modal_edit').modal('hide');
      $('#edit_report_modal').modal('show');
    },
    edit_report(report) {
      this.report_edit = report;
      this.edit_authors = report.authors;
      this.edit_author_input = this.edit_selected_author;
      const TextDescription = report.description;
      this.edit_report_link = report.report_link;
      this.report_id = report.id;
      this.edit_documents = report;
      this.selectedPortalId = report.portal?.id || '';
      this.selected_topic = report.topic?.id || '';
      this.selected_categories = report.tags?.map(tag => tag.tag_category) || [];
      this.comments_off = report.can_comment;

      // Initialize Maps
      this.primary_tags = new Map();
      this.selected_tags = new Map();

      // Set primary tag if exists
      if (report.primary_tag) {
        const catId = report.primary_tag.tag_category.id;
        this.primary_tags.set(catId, report.primary_tag);
        this.primary_tags = new Map(this.primary_tags); // reactive
        this.primary_tag = report.primary_tag; // <-- THIS is what was missing

      }

      // Prefill tags per category
      if (report.tags && Array.isArray(report.tags)) {
        report.tags.forEach(tag => {
          const catId = tag.tag_category.id;
          if (!this.selected_tags.has(catId)) this.selected_tags.set(catId, []);

          const catTags = this.selected_tags.get(catId);

          // If this tag is primary, add to front; else push normally
          if (report.primary_tag && tag.id === report.primary_tag.id) {
            catTags.unshift({
              id: tag.id,
              name: tag.name
            });
          } else {
            catTags.push({
              id: tag.id,
              name: tag.name
            });
          }

          this.selected_tags.set(catId, catTags);
        });
      }

      this.$nextTick(() => {
        const quillEditor = this.$refs.quillReportRef.getQuill();
        if (quillEditor) {
          quillEditor.clipboard.dangerouslyPasteHTML(TextDescription);

          quillEditor.root.addEventListener('paste', (e) => {
            const pastedText = e.clipboardData.getData('text');
            const match = pastedText.match(/(https?:\/\/[^\s]+)/g);
            if (match && match[0]) {
              report.report_link = match[0]; // update report object
              this.preview_link(report);
              this.edit_report_link = match[0];
            }
          });
        }
      });
    },
    handle_file_upload(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.type.startsWith('audio/')) {
          this.fileError = 'Audio files are not allowed.';
          this.upload_media = null;
          this.editFileName = '';
          event.target.value = '';
        } else {
          this.editFileName = file.name;
          this.fileError = '';
          this.upload_media = file;
        }
      } else {
        this.editFileName = '';
        this.fileError = '';
        this.upload_media = null;
      }
    },
    preview_link(report) {

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/fetch_url_meta/`,
        type: 'POST',
        data: { url: report.report_link },
        headers: { Authorization: `Token ${get_token()}` },
        success: (data) => { this.report_edit.linkPreview = data; },
      });
    },
    fetch_grouped_tags() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_tags/`,
        method: 'GET',
        headers: {
          Authorization: `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: response => {
          if (response.status === 'success') {
            const tag_list = response.data.tags;

            // ✅ store allowed tag ids for validation
            this.validTagIds = tag_list.map(tag => String(tag.id));
            this.validCategoryIds = tag_list.map(tag => String(tag.tag_category.id));


            const grouped = new Map();

            tag_list.forEach(tag => {
              const categoryName = tag.tag_category.name;
              const categoryId = tag.tag_category.id;

              if (!grouped.has(categoryName)) {
                grouped.set(categoryName, {
                  id: categoryId,
                  tags: []
                });
              }

              grouped.get(categoryName).tags.unshift({
                id: tag.id,
                name: tag.name
              });
            });

            this.categories = Array.from(grouped.entries()).map(
              ([name, { id, tags }]) => ({
                key: name.toLowerCase().replace(/\s+/g, '-'),
                id, // ✅ category id included here
                name,
                tags
              })
            );

            this.all_tags_by_category = grouped;
            this.categoryOptions = ['all', ...Array.from(grouped.keys()).sort()];
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    edit_report_data() {
      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we process your request.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.isSubmitting = true;
      const formData = new FormData();

      this.report_description = this.$refs.quillReportRef.getQuill().root.innerHTML.trim();
      formData.append('description', this.report_description);
      formData.append('can_comment', this.comments_off);
      formData.append('report_id', this.report_id);
      formData.append('authors', JSON.stringify(this.edit_authors))
      if (this.edit_report_link) {
        formData.append('report_link', this.edit_report_link);
      }
      if (this.upload_media) {
        formData.append('file', this.upload_media);
      }
      if (this.audio_file) {
        formData.append('file', this.audio_file, this.audio_file_name);
      }
      if (this.selected_topic) {
        formData.append('topic_id', this.selected_topic);
      }

      const tagIds = [];
      this.selected_tags.forEach(tagsArray => {
        tagsArray.forEach(tag => tagIds.push(tag.id));
      });
      tagIds.forEach(id => formData.append('tag_ids', id));

      // Only one primary tag
      if (this.primary_tag) {
        formData.append('primary_tag_id', this.primary_tag.id);
      };
      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_report_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === 'success') {
            const updatedReport = response.updated_data;
            const author_name = updatedReport.authors[0]?.author_name;
            updatedReport.author_name = author_name;
            updatedReport.report_link = this.edit_report_link;
            updatedReport.total_comments = updatedReport.total_comments || 0;

            const reportIndex = this.reports.findIndex(
              (hub) => hub.id === updatedReport.id
            );

            if (reportIndex !== -1) {
              this.reports.splice(reportIndex, 1, updatedReport);
              updatedReport.linkPreview = this.report_edit.linkPreview;
            }
            this.selected_report = updatedReport
            Swal.fire({
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              $('#edit_report_modal').modal('hide');
              this.edit_name = '';
              this.edit_description = '';
              this.files_to_remove = [];
            });
          }
        },
        error: (response) => {
          Swal.close();
          const response_data = response.responseJSON;
          this.errors.edit_name = response_data.message;
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    // keep your wrappers
    addNewReport(report) {
      this.add_new_report(report);
    },
    getFileIcon(fileUrl) {
      const iconMap = [
        { extensions: ['.pdf'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337946.png' },
        { extensions: ['.doc', '.docx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337932.png' },
        { extensions: ['.xls', '.xlsx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337958.png' },
        { extensions: ['.ppt', '.pptx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337950.png' },
        { extensions: ['.html', '.htm'], icon: 'https://cdn-icons-png.flaticon.com/128/732/732212.png' },
        { extensions: ['.csv'], icon: 'https://cdn-icons-png.flaticon.com/128/8242/8242984.png' },
      ];

      for (const { extensions, icon } of iconMap) {
        if (extensions.some(ext => fileUrl.includes(ext))) {
          return icon;
        }
      }

      return 'https://cdn-icons-png.flaticon.com/128/337/337940.png'; // Default file icon
    },
    getFileName(fileUrl) {
      const decodedUrl = decodeURIComponent(fileUrl);
      const cleanUrl = decodedUrl.split('?')[0];
      return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    },
    view_report(report) {
      this.selected_report = report;
      this.$nextTick(() => {
        $('#view_report_modal').modal('show');
      });
    },
    // Helper to strip HTML tags for descriptions
    add_new_report(report) {
      this.reports.unshift(report);
    },

    delete_report(report_id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'DELETE',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_report_api/`,
            data: { report_id: report_id },
            headers: {
              'Authorization': `Token ${this.getToken()}`,
            },
            success: () => {
              Swal.fire({
                icon: 'success',
                title: 'Feed deleted',
                showConfirmButton: false,
                timer: 2000,
                position: 'bottom-end',
                toast: true
              });
              this.reports = this.reports.filter(r => r.id !== report_id);
              $('#view_report_modal').modal('hide')
            },
            error: () => {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to delete the feed. Please try again.',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          });
        }
      });
    },
    // Toggles report visibility (disable/enable). Pass current disabled state so we can customize the confirmation.
    disable_report_method(report_id, currently_disabled) {
      const actionText = currently_disabled ? 'enable' : 'disable';
      const confirmButtonText = currently_disabled ? 'Yes, enable it!' : 'Yes, disable it!';
      const swalText = currently_disabled
        ? 'This will make the report visible again.'
        : 'You won\'t be able to view this report publicly after disabling it.';

      Swal.fire({
        title: `Are you sure you want to ${actionText} this report?`,
        text: swalText,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: confirmButtonText,
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/toggle_report_visibility/`,
            data: { report_id: report_id },
            headers: {
              'Authorization': `Token ${this.getToken()}`,
            },
            success: (response) => {
              const disabled = response.is_disabled;
              this.selected_report.is_disabled = response.is_disabled;

              Swal.fire({
                icon: 'success',
                title: disabled ? 'Feed disabled' : 'Feed enabled',
                showConfirmButton: false,
                timer: 2000,
                position: 'bottom-end',
                toast: true
              });
            },
            error: () => {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to change report visibility. Please try again.',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          });
        }
      });
    },
    fetch_reports() {
      this.is_loading = true;

      return new Promise((resolve) => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_all_reports_api/`,
          method: 'GET',
          data: append_active_organization_id({}),
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json',
          },
          success: (data) => {
            const response = data && data.response_data;
            if (response && response.status === 'success') {
              // backend may return an array directly or under report_data
              this.reports = response.data || [];
            } else {
              this.reports = [];
            }
            this.syncReportsTable(resolve);
          },
          error: () => {
            this.reports = [];
            this.syncReportsTable(resolve);
          },
          complete: () => {
            this.is_loading = false;
          },
        });
      });
    },

    fetch_reports_by_topic() {
      this.is_loading = true;

      return new Promise((resolve) => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_reports_by_topic/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json',
          },
          data: JSON.stringify({
            topic_id: Number(this.$route.params.topic_id),
          }),

          success: (data) => {
            const response = data;
            if (response && response.status === 'success') {
              this.reports = response.reports || [];
            } else {
              this.reports = [];
            }
            this.syncReportsTable(resolve);
          },
          error: () => {
            this.reports = [];
            this.syncReportsTable(resolve);
          },
          complete: () => {
            this.is_loading = false;
          },
        });
      });
    },
    fetch_reports_by_tags() {
      this.is_loading = true;
      // alert("Fetching reports for tag ID: " + this.$route.params.tag_id);
      return new Promise((resolve) => {
        let tagIdParam = this.$route.params.tag_id;

        // Make sure we send an array
        let tagIds = [];
        if (tagIdParam) {
          tagIds = [Number(tagIdParam)]; // always an array
        }
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_reports_by_tags/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json',
          },
          data: JSON.stringify({
            tag_ids: tagIds,
          }),

          success: (data) => {
            const response = data;
            this.reports = response.results || [];
            this.syncReportsTable(resolve);
          },
          error: () => {
            this.reports = [];
            this.syncReportsTable(resolve);
          },
          complete: () => {
            this.is_loading = false;
          },
        });
      });
    },
    getTextOnly(html) {
      return html.replace(/<[^>]*>/g, ''); // removes all HTML tags
    }

  }
};
